<script lang="ts" generics="TValues, TValue, TOption">
    import type { Field, Form } from '@jmvdevelop/svelte-form';
    import ModalMobile from '$components/Form/ModalMobile/ModalMobile.svelte';
    import RowInModal from '$components/Form/ModalMobile/RowInModal.svelte';
    import MobileCombobox from '$components/Form/ModalMobile/MobileCombobox.svelte';
    import DialogFragment from '$components/MeltUtils/DialogFragment.svelte';
    import { createAutoAbortHandler } from '$lib/utils/abort';
    import { safe } from '$lib/utils/string';
    import { escapeCss } from '$lib/utils/escapeCss.js';

    export let form: Form<TValues, string>;
    export let field: Field<TValues, TValue | null>;
    export let label: string;
    export let required: boolean = false;
    export let id: string | null = null;
    export let prefixId: string = '';
    export let modalTitle: string | null = null;

    export let loadOptions: (q: string) => Promise<TOption[]>;
    export let optionToValue: (option: TOption) => TValue;
    export let valueToOption: (value: TValue) => Promise<TOption | null>;

    let option: TOption | null = null;
    let handler = createAutoAbortHandler<TOption | null>();

    async function syncOption(value: TValue | null) {
        const o = await handler(
            value === null ? Promise.resolve(null) : valueToOption(value),
        );
        if (o.status === 'ok') {
            option = o.data;
        }
    }

    $: value = form.stores().fieldValue(field);
    $: syncOption($value);

    interface $$Slots {
        description: {
            class: string;
            option: TOption | null;
        };
        option: {
            option: TOption;
            inputValue: string;
        };
    }

    $: effectiveId = safe`${prefixId}-${id ?? form.getFieldId(field)}`;
    $: inputValueId = `${effectiveId}-inputValue`;
</script>

<RowInModal
    {form}
    {field}
    {label}
    {required}
    id={effectiveId}
    createDialogOpts={{
        openFocus: `#${escapeCss(inputValueId)}`,
    }}
    let:form
    let:field
    let:label
    let:dialog
>
    <slot
        slot="description"
        name="description"
        let:class={className}
        class={className}
        {option}
    />
    <ModalMobile
        {dialog}
        title={modalTitle ?? label}
        closeIcon="chevron"
        transitionStyle="push"
    >
        <DialogFragment {dialog} let:setOpen>
            <MobileCombobox
                {form}
                {field}
                {loadOptions}
                {optionToValue}
                {inputValueId}
                onSelect={() => setOpen(false)}
            >
                <slot
                    slot="option"
                    name="option"
                    let:option
                    let:inputValue
                    {option}
                    {inputValue}
                />
            </MobileCombobox>
        </DialogFragment>
    </ModalMobile>
</RowInModal>
